import type { SVGProps } from 'react';
const SvgPaperPlane = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" {...props}>
    <path d="m322.5 351.7 200.9-200.8L391 520.3zM489.4 117 288.6 317.8 120 249.3zM70.1 280.8l205.8 83.6 83.6 205.8c5.3 13.1 18.1 21.7 32.3 21.7 14.7 0 27.8-9.2 32.8-23.1L602.6 72c3.5-9.8 1-20.6-6.3-28s-18.2-9.8-28-6.3l-496.9 178c-13.9 5-23.1 18.1-23.1 32.8 0 14.2 8.6 27 21.7 32.3z" />
  </svg>
);
export default SvgPaperPlane;
